<template>
  <el-row>
    <el-table :data="customer.listAddress" style="width: 100%" max-height="250">
      <el-table-column fixed type="index" label="No"></el-table-column>
      <el-table-column prop="oracleSiteUseId" label="Oracle Site Use ID"></el-table-column>
      <el-table-column prop="shipToAddress" label="Ship To Address"></el-table-column>
      <el-table-column prop="billToAddress" label="Bill To Address"></el-table-column>
      <el-table-column sortable prop="status" label="Status">
        <template slot-scope="scope">
          <el-select v-model="scope.row.status" placeholder="Select" disabled>
            <el-option
              v-for="item in optionsActive"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="Operations">
        <template slot-scope="scope">
          <el-button size="mini" @click="toDetail(scope.row.oracleSiteUseId)">Detail</el-button>
        </template>
      </el-table-column>
    </el-table>

    <FormShipToAddress :DataCustomerAddress="customer" :Id="id" :OptionsActive="optionsActive" />
    <FormBillToAddress :DataCustomerAddress="customer" :Id="id" :OptionsActive="optionsActive" />
  </el-row>
</template>

<script>
import FormShipToAddress from "./FormShipToAddress";
import FormBillToAddress from "./FormBillToAddress";
export default {
  props: ["customer"],
  name: "SubStore",
  components: {
    FormShipToAddress,
    FormBillToAddress
  },
  data() {
    return {
      optionsActive: [
        { label: "Active", value: true },
        { label: "Tidak Active", value: false }
      ],
      id: null,
    };
  },
  methods: {
    toDetail(id) {
      this.id = id;
    }
  }
};
</script>

<style>
</style>
